import { FieldArray } from 'formik';
import { WebPageBlockType } from '../../../api/types';
import { type WebpageFormikValue } from './shared';
import ColumnBlock from './WebpageBlock/ColumnBlock';
import CustomBlock from './WebpageBlock/CustomBlock';
import ImageBlock from './WebpageBlock/ImageBlock';
import TextCarouselBlock from './WebpageBlock/TextCarouselBlock';
import TextImageBlock from './WebpageBlock/TextImageBlock';

type WebpageDetailsBlockProps = {
    name: string;
    disabled?: boolean;
};

const WebpageDetailsBlock = ({ name, disabled = false }: WebpageDetailsBlockProps) => (
    <FieldArray
        name={name}
        render={({ form }) => {
            const webPage = form.values as WebpageFormikValue;

            return webPage.webPageBlock.map((block, index) => {
                switch (block.type) {
                    case WebPageBlockType.Column:
                        return (
                            <ColumnBlock
                                key={block.id}
                                disabled={disabled}
                                index={index}
                                name={`webPageBlock.${index}`}
                            />
                        );

                    case WebPageBlockType.Custom:
                        return (
                            <CustomBlock
                                key={block.id}
                                disabled={disabled}
                                index={index}
                                name={`webPageBlock.${index}`}
                            />
                        );

                    case WebPageBlockType.Image:
                        return (
                            <ImageBlock
                                key={block.id}
                                disabled={disabled}
                                index={index}
                                name={`webPageBlock.${index}`}
                            />
                        );

                    case WebPageBlockType.TextImage:
                        return (
                            <TextImageBlock
                                key={block.id}
                                disabled={disabled}
                                index={index}
                                name={`webPageBlock.${index}`}
                            />
                        );

                    case WebPageBlockType.TextCarousel:
                        return (
                            <TextCarouselBlock
                                key={block.id}
                                disabled={disabled}
                                index={index}
                                name={`webPageBlock.${index}`}
                            />
                        );

                    default:
                        throw new Error('WebPageBlockType not support');
                }
            });
        }}
    />
);

export default WebpageDetailsBlock;
